import i18n from '@/../i18n'
import { SpecialField } from "@/services/hooks/useEmailTemplateSpecialFields/types";
import { ADDITIONAL_VALUE_LENGTH, REGEX_FALLBACK_VALUE } from "../constants";

export const getSpecialFieldWithFreeValueRegex = ({id, group,name,regexKeyword}: Pick<SpecialField, 'id'|'group'|'name'|'regexKeyword'>): SpecialField => (
    {
        id,
        group,
        name,
        additionalValueTitle: i18n.t('fallbackvalue'),
        additionalValueError: i18n.t('fallback_error'),
        isAdditionalValueRequired: false,
        additionalValueDescription: i18n.t('fallback_desc'),
        additionalValueMaxLength: ADDITIONAL_VALUE_LENGTH,
        regexFormat: new RegExp(`^${regexKeyword}(:${REGEX_FALLBACK_VALUE})?$`),
        regexKeyword,
        requiredText: i18n.t('optional'),
        autocompleteValue: regexKeyword
    }
);
